import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import {
  RECENT_CHANGES_FEATURE_OFF,
  RecentChangesParams,
  RecentChangesResponse,
} from 'src/app/models/home/recent-changes/recent-changes.model';
import { HOME_API_ROUTES } from './home-api-routes';

/**
 * Home IA · Radar de cambios recientes (R5 · ADR-R5-04). Read-only: expone el top-N de cambios
 * documentales relevantes (severidad alta/critica) que el backend ya recorto por permisos de
 * fuente. Ante 404 (plan sin `change_detection`) devuelve la respuesta "feature off" para que la
 * superficie se oculte por completo, sin propagar el error. Los demas errores si se propagan (los
 * maneja el estado del widget). account/user viajan por el JWT (interceptor); nunca como parametros.
 */
@Injectable({ providedIn: 'root' })
export class HomeRecentChangesService {
  private readonly defaultLimit = 5;

  constructor(private readonly api: ApiService) {}

  getRecentChanges(params?: RecentChangesParams): Observable<RecentChangesResponse> {
    const query: RecentChangesParams = { limit: params?.limit ?? this.defaultLimit };
    return this.api
      .get<RecentChangesResponse>(HOME_API_ROUTES.RECENT_CHANGES, query)
      .pipe(
        catchError((error) => {
          // 404 = feature no disponible para el plan: ocultar la superficie, no es un error de UI.
          if (error?.status === 404) {
            return of(RECENT_CHANGES_FEATURE_OFF);
          }
          return throwError(() => error);
        }),
      );
  }
}
